import React, { PropsWithChildren } from 'react';

import { cn } from '@/utils/classname';

interface AppRouteBodyProps extends PropsWithChildren {
  title: string;
  sectionClassName?: string;
  tablePadding?: boolean; // Default true for backward compatibility
  headerAction?: React.ReactNode; // Optional action element (e.g., search bar) to render in header
  'data-tutorial'?: string;
}

/**
 * This component is used to wrap the content of the page with the basic layout with the header
 *
 * Note: Removed blocking Loader wrapper that was causing blank page issues for share links.
 * Individual components should handle their own loading states instead of blocking the entire page.
 */
export const AppRouteBody = ({
  title,
  children,
  sectionClassName,
  tablePadding,
  headerAction,
  'data-tutorial': dataTutorial,
}: AppRouteBodyProps) => {
  return (
    <main
      className="flex size-full flex-col gap-4 overflow-hidden"
      data-tutorial={dataTutorial}
    >
      <header
        className={cn(
          'flex items-center px-6 text-2xl font-bold',
          headerAction ? 'justify-between' : ''
        )}
      >
        <span>{title}</span>
        {headerAction}
      </header>
      <section
        className={cn(
          'border-chariot-stroke bg-chariot-background-primary/60 relative flex size-full flex-col overflow-hidden rounded-md border-2',
          tablePadding !== false ? 'p-6' : '',
          sectionClassName
        )}
      >
        {children}
      </section>
    </main>
  );
};
